import type { SVGProps } from "react";

export const TUMLiveLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		{...props}
		aria-labelledby="tumlive-logo"
		style={{
			clipRule: "evenodd",
			fillRule: "evenodd",
			strokeLinejoin: "round",
			strokeMiterlimit: 2,
		}}
		viewBox="0 0 3840 2160"
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
	>
		<title id="tumlive-logo">
			TUM.live logo showing TUM before a red live text simulating an ongoing
			recording
		</title>
		<g transform="translate(0 153.82) scale(7.24975)">
			<clipPath id="a">
				<path d="M0 0h408.16v212.467H0z" />
			</clipPath>
			<g clipPath="url(#a)">
				<path
					d="M156.555 0v173.328h44.729V0H408.16v212.467h-39.139V39.139h-44.729v173.328h-39.139V39.139h-44.73v173.328H117.416V39.139H78.277v173.328H39.139V39.139H0V0h156.555Z"
					style={{
						fill: "#3070b3",
						fillRule: "nonzero",
					}}
				/>
			</g>
		</g>
		<path
			d="M3769.81 2002.61c42.87 0 77.62-38.84 77.62-86.75v-512.24c0-47.91-34.75-86.75-77.62-86.75h-1322.4c-42.87 0-77.63 38.84-77.63 86.75v512.24c0 47.91 34.76 86.75 77.63 86.75h1322.4Zm-77.63-173.51H2525.04v-338.72h1167.14v338.72Z"
			style={{
				fill: "#e5312b",
			}}
			transform="matrix(.96616 0 0 .86451 123.6 259.287)"
		/>
		<path
			d="M2447.41 1403.62h1322.4v512.234h-1322.4z"
			style={{
				fill: "#e74431",
			}}
			transform="matrix(.96616 0 0 .86451 123.6 259.287)"
		/>
		<path
			d="M2447.41 1403.62h1322.4v512.234h-1322.4z"
			style={{
				fill: "#e5312b",
			}}
			transform="matrix(.96616 0 0 .86451 123.6 259.287)"
		/>
		<path
			d="M.069-.714h.157v.582h.348V0H.069v-.714Z"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
			transform="matrix(620.21321 0 0 620.21321 2445.383 1915.564)"
		/>
		<path
			d="M.069-.714h.157V0H.069z"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
			transform="matrix(620.21321 0 0 620.21321 2813.162 1915.564)"
		/>
		<path
			d="M.401 0H.224l-.232-.714h.162l.159.502h.002l.161-.502h.162L.401 0Z"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
			transform="matrix(620.21321 0 0 620.21321 2996.133 1915.564)"
		/>
		<path
			d="M.069-.714h.534v.132H.226v.153h.346v.122H.226v.175h.385V0H.069v-.714Z"
			style={{
				fill: "#fff",
				fillRule: "nonzero",
			}}
			transform="matrix(620.21321 0 0 620.21321 3386.861 1915.564)"
		/>
	</svg>
);
